var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_3864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85156 14.2104H4.85156C4.58635 14.2104 4.33199 14.1106 4.14446 13.9329C3.95692 13.7553 3.85156 13.5143 3.85156 13.263V9.47356C3.85156 9.2223 3.95692 8.98133 4.14446 8.80366C4.33199 8.626 4.58635 8.52619 4.85156 8.52619H6.85156L10.3516 4.26303C10.439 4.10219 10.5842 3.97628 10.7611 3.90804C10.9379 3.8398 11.1347 3.83374 11.3158 3.89094C11.497 3.94815 11.6505 4.06485 11.7488 4.21996C11.847 4.37507 11.8835 4.55836 11.8516 4.73671V17.9999C11.8835 18.1782 11.847 18.3615 11.7488 18.5166C11.6505 18.6717 11.497 18.7884 11.3158 18.8456C11.1347 18.9028 10.9379 18.8968 10.7611 18.8285C10.5842 18.7603 10.439 18.6344 10.3516 18.4736L6.85156 14.2104Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8516 9.47363L16.8516 13.2631M16.8516 9.47363L20.8516 13.2631L16.8516 9.47363Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_3864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22.7368,
    fill: "white",
    transform: "translate(0.851562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/mute-icon.b388fd31bf4eb49a1cd922a8470776cd.svg";
export { ForwardRef as ReactComponent };